import { useQuery } from "@tanstack/react-query";
import { fetchRateCard } from "@/api/billing";
import { queryKeys } from "@/lib/query-keys";

/**
 * Loads the pricing-step rate card with a five-minute stale window and exposes
 * request failures through the React Query result.
 *
 * @returns Query data plus loading, error, and explicit refetch state; automatic
 *   retries are disabled.
 */
export const useRateCard = () => {
  return useQuery({
    queryKey: queryKeys.billing.rateCard(),
    queryFn: fetchRateCard,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};
